import React, { useState, useEffect } from 'react';
import { postExpress } from '../../../service/api';
import UserCopyMain from '../../presentation/section/admin-page/UserCopyMain';

const UserCopy = (props) => {
  const [email, setEmail] = useState('');
  const [copyemail, setCopyemail] = useState('');
  const [saveTooltip, setSaveTooltip] = useState('Loading...')

  const handleEmail = (event) => {
    setEmail(event.target.value)
  }

  const handleCopyEmail = (event) => {
    setCopyemail(event.target.value)
  }

  const handleCopy = () => {
    if (email == '' || copyemail == '') {
      setSaveTooltip('E-mail을 입력해주세요.')
    }
    else if (email == copyemail) {
      setSaveTooltip('동일한 E-mail입니다.')
    }
    else {
      postExpress('/account/copy', {
        email: email,
        copyemail: copyemail
      }, (response) => {
        if (response.data.code == 3) {
          setSaveTooltip('유효하지 않은 Base E-mail')
        }
        else if (response.data.code == 2) {
          setSaveTooltip('유효하지 않은 Copy E-mail')
        }
        else if (response.data.code == 0) {
          setSaveTooltip('Copy가 완료되었습니다.')
        }
        else {
          setSaveTooltip('Error발생. 관리자에게 말해주세요.')
        }
      })
    }
  }

  return (
    <UserCopyMain email={email} copyemail={copyemail} handleEmail={handleEmail} handleCopyEmail={handleCopyEmail}
      handleCopy={handleCopy} saveTooltip={saveTooltip}
    />
  )
}
export default UserCopy;
